import { CustomElement } from '@aurelia/runtime-html';
import * as d0 from "./modules/nav-bar.ts";
import * as d1 from "./components/auth/login-modal.ts";
export const name = "shell";
export const template = "\n\n\n<nav-bar home-url.one-time=\"homeUrl\" base-url.one-time=\"baseUrl\"></nav-bar>\n\n<login-modal></login-modal>\n\n<div style=\"padding-bottom:4rem; margin-top:1rem;\" class=\"container-lg\">\n  <au-viewport></au-viewport>\n</div>\n";
export default template;
export const dependencies = [ d0, d1 ];
export const bindables = {};
let _e;
export function register(container) {
  if (!_e) {
    _e = CustomElement.define({ name, template, dependencies, bindables });
  }
  container.register(_e);
}
